/**
 * Whether the HTML a rich-text editor holds says anything.
 *
 * An editor that was typed in and cleared is not `''`: it is `<p></p>` (or
 * `<p><br></p>`), so a naive truthiness check would let an empty note through.
 * Strips tags and non-breaking spaces and asks whether any text is left.
 */
export const isRichTextEmpty = (html) =>
  !html || html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim() === '';
